import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, Twitter } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gray-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/mez3d6kq_logo2.png" 
              alt="KargoPack" 
              className="h-14 mb-4"
            />
          </div>

          {/* Ürün Grupları */}
          <div>
            <h4 className="font-bold text-gray-900 mb-4">Ürün Grupları</h4>
            <ul className="space-y-2">
              <li><Link to="/urunler/baskisiz" className="text-gray-600 hover:text-[#E31E24] transition-colors">Baskısız Poşet</Link></li>
              <li><Link to="/urunler/baskili" className="text-gray-600 hover:text-[#E31E24] transition-colors">Baskılı Poşet</Link></li>
              <li><Link to="/urunler/kabarcikli" className="text-gray-600 hover:text-[#E31E24] transition-colors">Hava Kabarcıklı</Link></li>
              <li><Link to="/urunler/ozel-boyut" className="text-gray-600 hover:text-[#E31E24] transition-colors">Özel Boyut</Link></li>
            </ul>
          </div>

          {/* Kurumsal */}
          <div>
            <h4 className="font-bold text-gray-900 mb-4">Kurumsal</h4>
            <ul className="space-y-2">
              <li><Link to="/hakkimizda" className="text-gray-600 hover:text-[#E31E24] transition-colors">Hakkımızda</Link></li>
              <li><Link to="/hakkimizda/degerler" className="text-gray-600 hover:text-[#E31E24] transition-colors">Temel Değerler</Link></li>
              <li><Link to="/kalite" className="text-gray-600 hover:text-[#E31E24] transition-colors">Kalite Politikası</Link></li>
              <li><Link to="/sertifikalar" className="text-gray-600 hover:text-[#E31E24] transition-colors">Sertifikalar</Link></li>
            </ul>
          </div>

          {/* Sürdürülebilirlik */}
          <div>
            <h4 className="font-bold text-gray-900 mb-4">Sürdürülebilirlik</h4>
            <ul className="space-y-2">
              <li><Link to="/surdurulebilirlik/gelecek" className="text-gray-600 hover:text-[#E31E24] transition-colors">Gelecek İçin</Link></li>
              <li><Link to="/surdurulebilirlik/musteriler" className="text-gray-600 hover:text-[#E31E24] transition-colors">Müşteriler İçin</Link></li>
              <li><Link to="/surdurulebilirlik/calisanlar" className="text-gray-600 hover:text-[#E31E24] transition-colors">Çalışanlar İçin</Link></li>
            </ul>
          </div>

          {/* Kategoriler */}
          <div>
            <h4 className="font-bold text-gray-900 mb-4">Kategoriler</h4>
            <ul className="space-y-2">
              <li><Link to="/blog" className="text-gray-600 hover:text-[#E31E24] transition-colors">Blog</Link></li>
              <li><Link to="/iletisim" className="text-gray-600 hover:text-[#E31E24] transition-colors">İletişim</Link></li>
              <li><Link to="/kariyer" className="text-gray-600 hover:text-[#E31E24] transition-colors">Kariyer</Link></li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#E31E24] flex items-center justify-center transition-colors group">
                <Instagram className="w-5 h-5 text-gray-600 group-hover:text-white" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#E31E24] flex items-center justify-center transition-colors group">
                <Twitter className="w-5 h-5 text-gray-600 group-hover:text-white" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#E31E24] flex items-center justify-center transition-colors group">
                <Facebook className="w-5 h-5 text-gray-600 group-hover:text-white" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-200 hover:bg-[#E31E24] flex items-center justify-center transition-colors group">
                <Linkedin className="w-5 h-5 text-gray-600 group-hover:text-white" />
              </a>
            </div>
            <div className="text-gray-600 text-sm">
              <p>© 2025 KargoPack Plastik Ambalaj San. Tic. A.Ş.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
